export default "/img/VE.27bd663029e8c20b1ebdc0a4f8ec5fff.png";